<style>
    #q-info-btn {
        width: 140px;
        font-size: 80%;

    }
</style>
<template>
    <div class="dev-only mb-2" id="q-info-btn">
        <small> 
            <button class="btn btn-sm btn-link" @click="$emit('update:modelValue', !modelValue)" ><strong>{{ buttonText }}</strong></button>
        </small>
    </div>
</template>
<script>
    export default {
        props: ['modelValue'],
        emits: ['update:modelValue'],
        computed: {
            buttonText: function() {
                return (this.modelValue) ? 'Hide question info' : 'Show question info';
            }
        }
    }
</script>